import { Box, IconButton as MUIIconButton, SxProps, Tooltip } from "@mui/material";
import React from "react";

/**
 * IconButton is a wrapper around the IconButton component that adds a tooltip to the IconButton.
 */
interface IconButtonProps {
    title: string;
    icon: React.ReactNode;
    badgeSx?: SxProps;
    badgeContent?: React.ReactNode;
    placement?: "top" | "bottom" | "left" | "right" | undefined;
    [key: string]: any;
}
export function IconButton({
    title,
    icon,
    badgeSx = {},
    badgeContent,
    placement = undefined,
    ...props
}: IconButtonProps) {
    return (
        <Box display={"flex"} alignItems={"center"} justifyContent={"center"} position={"relative"}>
            {badgeContent && (
                <Box
                    sx={{
                        pointerEvents: "none",
                        position: "absolute",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        top: 5,
                        right: -12,
                        borderRadius: 2,
                        zIndex: 2,
                        ...badgeSx,
                    }}
                >
                    {badgeContent}
                </Box>
            )}
            <Tooltip arrow placement={placement} title={title}>
                <MUIIconButton {...props}>{icon}</MUIIconButton>
            </Tooltip>
        </Box>
    );
}
